module.exports = __webpack_public_path__ + "static/media/pha.bd1da532.ogg";